import { Select } from 'antd'
import { t } from 'i18next'
import { useEffect, useState } from 'react'
import { ofrTemplateTypes, OfrTemplateType } from '../constants/constants'

interface SelectAnnotationTypeProps {
  defaultValue?: OfrTemplateType
  value?: OfrTemplateType
  onChange?: (value: OfrTemplateType) => void
  style?: Object
  loading?: boolean
  disabled?: boolean
  placeholder?: string
}

const SelectAnnotationType = ({
  defaultValue,
  value,
  onChange,
  style,
  loading,
  disabled,
  placeholder,
}: SelectAnnotationTypeProps) => {
  const templateTypeOptions = Object.values(ofrTemplateTypes).map((type) => ({
    label: t(`createOfrDocumentTemplateModal.${type}`),
    value: type,
  }))
  const [selectedValue, setSelectedValue] = useState<OfrTemplateType | undefined>(
    defaultValue
  )

  useEffect(() => {
    if (value) {
      setSelectedValue(value)
    }
  }, [value])

  return (
    <Select
      value={selectedValue}
      placeholder={placeholder || t('selectAnnotationType.placeholder')}
      onChange={onChange}
      options={templateTypeOptions}
      style={style}
      loading={loading}
      disabled={disabled}
    />
  )
}

export default SelectAnnotationType
